import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { useUserPortal } from '../../hooks/useUserPortal';
var SettingsContext = createContext(undefined);
export var useSettings = function () {
    var context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};
var initialShopSettings = {
    isShopAdded: false,
    isWebhookAdded: false,
    isExtraSettingsAdded: false,
};
export var SettingsProvider = function (_a) {
    var children = _a.children, shopId = _a.shopId;
    var _b = useUserPortal(), userPortal = _b.userPortal, isLoadingUserPortal = _b.isLoading;
    var _c = useState(function () {
        if (!shopId) {
            return initialShopSettings;
        }
        var saved = localStorage.getItem("shopSettings_".concat(shopId));
        if (!saved) {
            return initialShopSettings;
        }
        try {
            return JSON.parse(saved);
        }
        catch (_a) {
            return initialShopSettings;
        }
    }), shopSettings = _c[0], setShopSettings = _c[1];
    var value = {
        userPortal: userPortal,
        isLoadingUserPortal: isLoadingUserPortal,
        shopSettings: shopSettings,
        setShopSettings: function (newSettings) {
            setShopSettings(newSettings);
            if (shopId) {
                var settingsToSave = typeof newSettings === 'function' ? newSettings(shopSettings) : newSettings;
                localStorage.setItem("shopSettings_".concat(shopId), JSON.stringify(settingsToSave));
            }
        },
    };
    return _jsx(SettingsContext.Provider, { value: value, children: children });
};
